var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export var scrollTrigger = function (target, trigger, options) {
    gsap.to(target, __assign({ scrollTrigger: {
            trigger: trigger,
            start: "top bottom",
            scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        } }, options));
};
